<!--Article Page-->
<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    element-loading-background="rgba(255, 255, 255, 0.8)"
    class="news-detail-page events-detail-page mb-4"
  >
    <div v-if="event">
      <events-header
        :image="imageForEvent"
      ></events-header>

      <div class="news-content content-container">
        <div class="container">
          <el-row>
            <el-col
              :md="24"
              :lg="16"
              class="left-content"
            >
              <h2
                id="main-content"
                class="news-title"
              >
                {{ event.title }}
              </h2>

              <div class="d-flex mt-3">
                <div class="type-article">
                  {{ event.type.label }}
                </div>
                <div class="added-on">
                  Added: {{ formatDate(event.date) }}
                </div>
              </div>
              <!-- Physical event -->
              <div class="address-information">
                <el-row>
                  <el-col
                    :md="24"
                    :lg="12"
                  >
                    <div
                      v-if="event.type.value == 'event'"
                      class="d-flex mt-4"
                    >
                      <svg-map-pin />
                      <div class="address d-flex flex-column">
                        <p class="address-line-p">
                          {{ event.address_line_1 }}
                        </p>
                        <p
                          v-if="event.address_line_2"
                          class="address-line-p"
                        >
                          {{ event.address_line_2 }}
                        </p>
                        <p class="address-line-p">
                          {{ event.city }}
                        </p>
                        <p class="address-line-p">
                          {{ event.postcode }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-else
                      class="mt-4"
                    >
                      <a
                        v-if="event.online_url"
                        :href="event.online_url"
                        target="_blank"
                      >{{ event.online_url }} <svg-link-green class="mr-2" /></a>
                      <p v-else>
                        Join details coming soon
                      </p>
                    </div>
                  </el-col>
                  <el-col
                    :md="24"
                    :lg="12"
                  >
                    <div class="d-flex flex-column">
                      <div class="d-flex mt-4">
                        <svg-calendar></svg-calendar>
                        <p class="information-p">
                          <span v-if="event.start_date">{{ formatDate(event.start_date) }}</span><span v-if="event.start_date && event.end_date">-</span><span v-if="event.end_date">{{ formatDate(event.end_date) }}</span>
                        </p>
                      </div>
                      <div class="d-flex mt-4">
                        <svg-time></svg-time>
                        <p class="information-p">
                          {{ event.start_time }} - {{ event.end_time }}
                        </p>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <hr class="content-hr" />
              <div
                class="news-content"
                v-html="$options.filters.domPurify(content)"
              ></div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import store from '../../../store'
import EventsHeader from '@/components/partials/events-header'
import SvgLinkGreen from '@/components/assets/svg-link-purple'
import Calendar from '@/components/assets/svg-news'
import MapPin from '@/components/assets/svg-map-pin'
import Time from '@/components/assets/svg-time'
import moment from 'moment';

import beWellCmsApi from "@/services/be-well-cms.api";
export default {
  name: 'EventsDetails',
  metaInfo: {
    title: "Events"
  },
  components: {
    'events-header': EventsHeader,
    'svg-map-pin': MapPin,
    'svg-time': Time,
    'svg-calendar': Calendar,
    SvgLinkGreen,
  },
  data() {
    return {
      event: null,
      eventHost: null,
      feedbackModalVisible: false,
      listenNowClicked: false,
      mainLoader: true,
      relatedItems: [],
      waitlingLoader: false,
      slotToRemoveBookingFrom: null,
      dayToRemoveBookingFrom: null,
      bookSlotEditMode: false,
      dialogs: {
        leaveWebinar: false,
        signUpForEvent: false,
        cancelEventAttendance: false,
        cancel121EventAttendance: false,
        cancel121BookedTimeSlot: false,
        bookA121TimeSlot: false,
        removeGuestFrom121: false,
      },
      leaveWebinarLoading: false,
    }
  },
  computed: {
    imageForEvent() {
      return this.event.has_feature_image
        ? this.event.feature_image.url
        : null;
    },
    content(){
      let cloneDiv = document.createElement("div");
      cloneDiv.innerHTML = this.event?.content?.length ?this.event.content[0].text : '' ;
      return cloneDiv.innerHTML.replaceAll('&nbsp;','')
    },
    formatDate(){
      return (date) => {
        return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY')
      }
    }
  },
  watch: {
    $route(to) {
      this.mainLoader = true

      beWellCmsApi.show('events',to.params.id).then(response => 
      {
        this.event = response.data

      }).catch(() => {
        this.$router.push({name: 'Events and Webinars'})
      }).finally(()=>{
        this.mainLoader = false
      })

    },
  },
  created() {
    if(store.state.user.isLogged){
      this.fetchEvent();
    }
  },
  methods: {

    fetchEvent() {

      beWellCmsApi.show('events',this.$route.params.id).then(response => 
      {
        this.event = response.data

      }).catch(() => {
        this.$router.push({name: 'Events and Webinars'})
      }).finally(()=>{
        this.mainLoader = false
      })
    },
  }
}
</script>
